<template>
  <v-hover v-slot:default="{ hover }">
    <div class="py-1">
      <v-row no-gutters align="start">
        <v-col cols="1">
          <v-avatar size="32" color="grey grey lighten 2">
            <v-icon small color="white">mdi-bell</v-icon>
          </v-avatar>
        </v-col>
        <v-col cols="11">
          <v-row no-gutters>
            <span class="text-body-2 font-weight-medium mr-1">{{ alert.autor }}</span>
            <v-spacer></v-spacer>
            <v-tooltip top v-if="hover">
              <template v-slot:activator="{ on }">
                <v-icon small icon class="pr-1" color="primary" v-on="on" @click="edit">mdi-pencil</v-icon>
              </template>
              <span>{{ $t('Edit') }}</span>
            </v-tooltip>
            <v-tooltip top v-if="hover">
              <template v-slot:activator="{ on }">
                <v-icon small icon color="red" v-on="on" @click="remove">mdi-delete</v-icon>
              </template>
              <span>{{ $t('Delete') }}</span>
            </v-tooltip>
            <v-icon small class="ml-2" :color="alert.notifyByEmail ? 'success' : 'error'">mdi-email</v-icon>
            <span class="ml-2 text-caption grey--text">{{ alert.date }}</span>
          </v-row>
          <v-row no-gutters>
            <v-col>
              <span class="text-body-2" v-html="alert.description"></span>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-divider class="my-1" />
    </div>
  </v-hover>
</template>

<script>
import Utils from '@/ecm/common/Utils';
export default {
    props: {
        alert: {
            type: Object
        }
    },
    methods: {
        edit() {
            this.$emit('on-edit-alert', Utils.object.toJS(this.alert));
        },
        remove() {
            this.$emit('on-remove-alert', this.alert.id);
        }
    }
};
</script>